<template>
  <div
    class="conversation-item flex"
    :class="isChecked"
    @click="selectConversation"
  >
    <div class="list-left">
      <UserAvatar :src="conversation.avatar" :shape="shape" />
      <div class="unread-box">
        <span class="unread-num" v-if="conversation.unreadCount != 0">{{
          conversation.unreadCount
        }}</span>
      </div>
    </div>
    <div class="user-name ellipsis" :title="conversation.name">
      {{ conversation.name }}
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import UserAvatar from "../UserAvatar";
export default {
  name: "conversation-item",
  props: {
    conversation: Object,
  },
  data() {
    return {
      shape: "chat-terse",
    };
  },
  components: {
    UserAvatar,
  },
  computed: {
    ...mapGetters(["currentConversation"]),
    isChecked() {
      if (
        this.conversation.sessionId == this.currentConversation.conversationID
      ) {
        return "checked";
      } else {
        return "";
      }
    },
  },
  methods: {
    selectConversation() {
      this.$emit("handClick", this.conversation);
    },
  },
};
</script>
<style scoped>
.conversation-item {
  padding: 5px 7px;
  margin-bottom: 1px;
}

.conversation-item .user-name {
  margin-left: 5px;
  line-height: 35px;
}

.conversation-item.checked {
  background-color: #dcecff;
}

.conversation-item:hover {
  background-color: #dcecff;
}

.list-left {
  position: relative;
}

.list-left .unread-box {
  position: absolute;
  top: 17px;
  left: 8px;
}

.unread-box .unread-num {
  min-width: 10px;
  height: 20px;
  padding: 0 6px;
  line-height: 20px;
  text-align: center;
  color: #fff;
  background-color: #ff5722;
  border-radius: 3px;
  z-index: 2;
}
</style>